import React from "react";
import { cn } from "../../lib/utils";

export interface MobileInfoRow {
  label: string;
  value: React.ReactNode;
  /** Makes the value tappable, e.g. `tel:` links. */
  href?: string;
}

/** Grouped label/value rows, like a native settings/detail list. */
const MobileInfoCard: React.FC<{
  title?: string;
  rows: Array<MobileInfoRow | false | "" | null | undefined>;
  className?: string;
}> = ({ title, rows, className }) => {
  const visibleRows = rows.filter((row): row is MobileInfoRow => !!row);
  if (visibleRows.length === 0) return null;

  return (
    <section className={cn("space-y-2", className)}>
      {title && (
        <h2 className="px-1 text-xs font-semibold uppercase tracking-wide text-gray-400">
          {title}
        </h2>
      )}
      <dl className="divide-y divide-gray-100 overflow-hidden rounded-2xl border border-gray-100 bg-white">
        {visibleRows.map((row) => (
          <div
            key={row.label}
            className="flex items-start justify-between gap-4 px-4 py-3"
          >
            <dt className="shrink-0 text-[13px] text-gray-500">{row.label}</dt>
            <dd className="min-w-0 break-words text-right text-[13px] font-medium text-gray-900">
              {row.href ? (
                <a
                  href={row.href}
                  className="text-primary-600 no-underline active:opacity-60"
                >
                  {row.value}
                </a>
              ) : (
                row.value
              )}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
};

export default MobileInfoCard;
